<script setup>
import { useRouter } from "vue-router";
import SidebarEntries from "./SidebarEntries.vue";
import sidebar from "./sidebar.js";
import { deleteCookie } from "./utils.js";
import { user } from "./auth.js";

const router = useRouter();

const appTitle = process.env.VUE_APP_TITLE;
const appDescription = process.env.VUE_APP_DESCRIPTION;

function logout() {
    deleteCookie("ticp_session");
    // Reload the current page so the user is brought to the TICP
    // login form
    router.go(0);
}
</script>

<template>
    <div class="d-flex flex-column min-vh-100">
        <!-- ---------------------------------------------------------------- -->
        <!-- Header -->
        <!-- ---------------------------------------------------------------- -->
        <div>
            <header>
                <div class="p-3">
                    <h1>{{ appTitle }}</h1>
                    <span>{{ appDescription }}</span>
                </div>
                <div class="d-flex justify-content-end pe-3 pb-1">
                    <template v-if="user">
                        <span>Utente attuale: {{  user.email }}</span>
                        <span class="ms-3 me-3">||</span>
                        <a class="logout" @click="logout">Logout</a>
                    </template>
                </div>
            </header>
        </div>
        <!-- ---------------------------------------------------------------- -->
        <!-- Body -->
        <!-- ---------------------------------------------------------------- -->
        <main class="flex-grow-1 d-flex flex-row">
            <div class="sidebar p-3">
                <SidebarEntries :entries="sidebar" :level="0"></SidebarEntries>
            </div>
            <div class="flex-grow-1 p-3">
                <!-- {% if pageTitle or pageDescription %}
                <div class="mb-3 text-muted">
                    <h6 class="mb-0">{{ pageTitle if pageTitle else "&nbsp;" | safe }}</h6>
                    <span class="">{{ pageDescription if pageDescription else "&nbsp;" | safe }}</span>
                </div>
                {% endif %} -->
                <div class="container-fluid p-0">
                    <router-view v-slot="{ Component }">
                        <component :is="Component" />
                    </router-view>
                </div>
            </div>
        </main>
        <!-- ---------------------------------------------------------------- -->
        <!-- Footer -->
        <!-- ---------------------------------------------------------------- -->
        <footer class="p-3">Piattaforma sviluppata e mantenuta da Telecash.it</footer>
    </div>
</template>
